var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32432 9.06465L2.80219 11.0138L0.893818 11.0542C0.323496 9.99638 0 8.78609 0 7.49996C0 6.25628 0.302461 5.08347 0.838594 4.05078H0.839004L2.53799 4.36227L3.28225 6.05105C3.12647 6.50519 3.04157 6.99269 3.04157 7.49996C3.04163 8.05051 3.14136 8.578 3.32432 9.06465Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8691 6.09863C14.9552 6.55232 15.0002 7.02087 15.0002 7.49973C15.0002 8.03668 14.9437 8.56045 14.8361 9.06567C14.4711 10.7849 13.5171 12.2861 12.1955 13.3485L12.1951 13.3481L10.0551 13.2389L9.75227 11.3482C10.6292 10.8339 11.3145 10.0291 11.6755 9.06567H7.66504V6.09863H11.734H14.8691Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1947 13.3481L12.1951 13.3485C10.9098 14.3816 9.27706 14.9997 7.49974 14.9997C4.64356 14.9997 2.16032 13.4033 0.893555 11.054L3.32405 9.06445C3.95742 10.7548 5.58806 11.9581 7.49974 11.9581C8.32143 11.9581 9.09123 11.736 9.75179 11.3482L12.1947 13.3481Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.287 1.72664L9.85733 3.71578C9.17369 3.28846 8.36557 3.0416 7.49978 3.0416C5.54483 3.0416 3.8837 4.30011 3.28206 6.05109L0.838789 4.05082H0.838379C2.0866 1.64423 4.60115 0 7.49978 0C9.31956 0 10.9881 0.648223 12.287 1.72664Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGg);
export default __webpack_public_path__ + "static/media/ic-gg.c070774713e2aa92cea7557b78778f9c.svg";
export { ForwardRef as ReactComponent };